import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Crown, Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import { api } from '../../utils/api';

const Footer = () => {
  const [brandSettings, setBrandSettings] = useState(null);

  useEffect(() => {
    api.getBrandSettings().then(res => setBrandSettings(res.data)).catch(console.error);
  }, []);

  return (
    <footer className="bg-[#3E2723] text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Crown className="h-8 w-8" strokeWidth={1.5} />
              <span className="font-serif text-2xl font-medium">{brandSettings?.business_name || 'Crowns by Preshy'}</span>
            </div>
            <p className="text-white/80 text-sm mb-4">{brandSettings?.tagline || 'Wear Your Crown Beautifully'}</p>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2 text-sm">
              <Link to="/services" className="text-white/80 hover:text-white transition-colors">Services</Link>
              <Link to="/gallery" className="text-white/80 hover:text-white transition-colors">Gallery</Link>
              <Link to="/about" className="text-white/80 hover:text-white transition-colors">About Us</Link>
              <Link to="/contact" className="text-white/80 hover:text-white transition-colors">Contact</Link>
              <Link to="/faq" className="text-white/80 hover:text-white transition-colors">FAQ</Link>
              <Link to="/policies" className="text-white/80 hover:text-white transition-colors">Policies</Link>
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Contact</h4>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-center gap-2 text-white/80">
                <Mail className="h-4 w-4" />
                {brandSettings?.contact_email || 'crownbypreshy@gmail.com'}
              </div>
              {brandSettings?.contact_phone && (
                <div className="flex items-center gap-2 text-white/80">
                  <Phone className="h-4 w-4" />
                  {brandSettings.contact_phone}
                </div>
              )}
              {brandSettings?.address && (
                <div className="flex items-center gap-2 text-white/80">
                  <MapPin className="h-4 w-4" />
                  {brandSettings.address}
                </div>
              )}
            </div>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-4">Follow Us</h4>
            <div className="flex gap-4">
              {brandSettings?.instagram && (
                <a href={brandSettings.instagram} target="_blank" rel="noopener noreferrer" className="hover:text-[#F3EBE1] transition-colors">
                  <Instagram className="h-5 w-5" />
                </a>
              )}
              {brandSettings?.facebook && (
                <a href={brandSettings.facebook} target="_blank" rel="noopener noreferrer" className="hover:text-[#F3EBE1] transition-colors">
                  <Facebook className="h-5 w-5" />
                </a>
              )}
              {brandSettings?.twitter && (
                <a href={brandSettings.twitter} target="_blank" rel="noopener noreferrer" className="hover:text-[#F3EBE1] transition-colors">
                  <Twitter className="h-5 w-5" />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-12 pt-8 text-center text-sm text-white/60">
          <p>© {new Date().getFullYear()} {brandSettings?.business_name || 'Crowns by Preshy'}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
